(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Hero: deal the slabs once, then let them follow the pointer
  function initCase(root){
    var cs = root.querySelector('.oh__case');
    if(!cs || cs.dataset.ready) return;
    cs.dataset.ready = 1;
    if(!reduce) cs.classList.add('is-dealt');
    cs.querySelectorAll('.slab').forEach(function(s){
      s.addEventListener('pointermove', function(e){
        var r = s.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        s.style.setProperty('--mx', (x*100).toFixed(1)+'%');
        s.style.setProperty('--my', (y*100).toFixed(1)+'%');
        if(!reduce){
          s.style.setProperty('--ry', ((x-.5)*16).toFixed(2)+'deg');
          s.style.setProperty('--rx', ((.5-y)*16).toFixed(2)+'deg');
        }
      });
      s.addEventListener('pointerleave', function(){
        s.style.setProperty('--rx','0deg'); s.style.setProperty('--ry','0deg');
      });
    });
  }

  // Badges for theme product cards (collection, search, recommendations)
  function badgesFor(title){
    var t = ' ' + title + ' ', out = [];
    var g = t.match(/\b(PSA|BGS|SGC|CGC)\s?(10|9\.5|[1-9](?:\.5)?)\b/i);
    if(g) out.push(['ob' + (g[2]==='10'?' ob--g10':''), g[1].toUpperCase()+' '+g[2]]);
    if(/\b1\/1\b|\b1 of 1\b/i.test(t)) out.push(['ob ob--11','1 of 1']);
    else { var s = t.match(/\s(\d{0,3}\/\d{1,4})\b/); if(s) out.push(['ob ob--sn', s[1].replace(/^\d+(?=\/)/, function(m){return m;})]); }
    if(/\b(RC|rookie)\b/i.test(t)) out.push(['ob ob--rc','RC']);
    if(/\bauto(graph)?s?\b|\bRPA\b|signature/i.test(t)) out.push(['ob ob--au','AUTO']);
    return out;
  }
  function decorate(root){
    root.querySelectorAll('product-card:not([data-ob])').forEach(function(card){
      card.setAttribute('data-ob','1');
      var tEl = card.querySelector('[class*="title"], a[href*="/products/"]');
      var title = (tEl && tEl.textContent || '').trim();
      var b = badgesFor(title); if(!b.length) return;
      var img = card.querySelector('img'); if(!img) return;
      var host = img.closest('[class*="gallery"], [class*="media"], picture') || img.parentElement;
      host = host.parentElement && host.tagName==='PICTURE' ? host.parentElement : host;
      if(getComputedStyle(host).position==='static') host.style.position='relative';
      var wrap = document.createElement('div'); wrap.className='obs';
      b.forEach(function(x){ var s=document.createElement('span'); s.className=x[0]; s.textContent=x[1]; wrap.appendChild(s); });
      host.appendChild(wrap);
    });
  }

  function run(){ document.querySelectorAll('.oh').forEach(initCase); decorate(document); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', run); else run();
  new MutationObserver(function(){ decorate(document); }).observe(document.documentElement,{childList:true,subtree:true});
})();
